import { Component } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { InitializeService } from './services/initialize.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent {
	constructor(
		private platform: Platform,
		private splashScreen: SplashScreen,
		private initializeService: InitializeService,
		private navCtrl: NavController
	) {
		this.initializeApp();
	}

	initializeApp() {
		this.platform.ready().then(() => {
			this.splashScreen.hide();
			this.initializeService.initSession();
		});
	}

	goTo(page: string, el: string = '', offset: number = 0) {
		if (el) {
			this.navCtrl.navigateForward(page, { queryParams: { el, offset } }).then();
			return;
		}
		this.navCtrl.navigateForward(page).then();
	}
}
